module.exports = __webpack_public_path__ + "media/images/background/bg-shape-1-dark-1c53457238f96f280980d7a9355bd96e.jpg";